import { useCallback, useEffect, useRef } from 'react';
import { LINKEDIN_OAUTH2_STATE } from './utils';
//import axios from 'axios';
//import { liAuthUrl } from '../settings-code.js';

const getPopupPositionProperties = ({ width = 600, height = 600 }) => {
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  return `left=${left},top=${top},width=${width},height=${height}`;
};

const generateRandomString = (length = 20) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};


export function useLinkedIn({
  redirectUri,
  clientId,
  onSuccess,
  onError,
  // scope = 'r_liteprofile r_emailaddress', // used for older LinkedIn Sign In without OpenID Connect
  scope = 'openid profile email', // For LinkedIn Sign In with OpenID Connect
  state = '',
  closePopupMessage = 'User closed the popup',
}) {
  const popupRef = useRef(null);
    const popUpIntervalRef = useRef(null);
//    const [authUrl, setAuthUrl] = useState(null);

  const receiveMessage = useCallback(
    (event) => {
      const savedState = localStorage.getItem(LINKEDIN_OAUTH2_STATE);
      if (event.origin === window.location.origin) {
        if (event.data.errorMessage && event.data.from === 'Linked In') {
          // Prevent CSRF attack by testing state
          if (event.data.state !== savedState) {
            popupRef.current && popupRef.current.close();
            return;
          }
          onError && onError(event.data);
          popupRef.current && popupRef.current.close();
        } else if (event.data.code && event.data.from === 'Linked In') {
          // Prevent CSRF attack by testing state
          if (event.data.state !== savedState) {
            console.error('State does not match');
            popupRef.current && popupRef.current.close();
            return;
          }
          onSuccess && onSuccess(event.data.code);
          popupRef.current && popupRef.current.close();
        }
      }
    },
    [onError, onSuccess],
  );

  useEffect(() => {
    return () => {
      window.removeEventListener('message', receiveMessage, false);

      if (popupRef.current) {
        popupRef.current.close();
        popupRef.current = null;
      }
      if (popUpIntervalRef.current) {
        window.clearInterval(popUpIntervalRef.current);
        popUpIntervalRef.current = null;
      }
    };
  }, [receiveMessage]);

  useEffect(() => {
    window.addEventListener('message', receiveMessage, false);
    return () => {
      window.removeEventListener('message', receiveMessage, false);
    };
  }, [receiveMessage]);

  const getUrl = () => {
    const scopeParam = `&scope=${encodeURI(scope)}`;
    const generatedState = state || generateRandomString();
    localStorage.setItem(LINKEDIN_OAUTH2_STATE, generatedState);
      const linkedInAuthLink = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}${scopeParam}&state=${generatedState}`;
      // console.log("redirecturi="+redirectUri);
      return linkedInAuthLink;
  };

    /*
    const getUrl2 = async () => {
        const scopeParam = `&scope=${encodeURI(scope)}`;
        const generatedState = localStorage.getItem(LINKEDIN_OAUTH2_STATE);
        const fetched_url = await axios.get(liAuthUrl + scopeParam + "&state=" + generatedState+"&redirect_uri="+redirectUri);
        console.log(fetched_url);
        / *
        axios.post(liAuthlUrl, { state: generatedState, scopeParam: scopeParam, redirect_uri: redirectUri })
            .then(response => { console.log(response); return response.data.body; })
            .then(fetchedAuthUrl => {
                window.open(fetchedAuthUrl, '_blank', getPopupPositionProperties({ width: 600, height: 600 }));
            });
        * /
};
*/

    const linkedInLogin = () => {
    popupRef.current?.close();
    popupRef.current = window.open(
      getUrl(),
      '_blank',
      getPopupPositionProperties({ width: 600, height: 600 }),
    );

    if (popUpIntervalRef.current) {
      window.clearInterval(popUpIntervalRef.current);
      popUpIntervalRef.current = null;
    }
    popUpIntervalRef.current = window.setInterval(() => {
      try {
        if (popupRef.current && popupRef.current.closed) {
          window.clearInterval(popUpIntervalRef.current);
          popUpIntervalRef.current = null;
          if (onError) {
            onError({
              error: 'user_closed_popup',
              errorMessage: closePopupMessage,
            });
          }
        }
      } catch (error) {
        console.error(error);
        window.clearInterval(popUpIntervalRef.current);
        popUpIntervalRef.current = null;
      }
    }, 1000);
  };

  return {
    linkedInLogin,
  };
}
